var HtmlComponent_default = {
  "htmlComponent": "kWsfQ",
  "htmlComponent_placeholder": "N8-cL"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
